import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Plus, Trash2 } from 'lucide-react';

export const emptyPartner = () => ({ name: '', profit_share_pct: '', email: '' });

export const partnersTotal = (partners) => partners.reduce((s, p) => s + (parseFloat(p.profit_share_pct) || 0), 0);

export const PartnersEditor = ({ partners, onChange, disabled = false }) => {
  const update = (i, patch) => onChange(partners.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));
  const total = partnersTotal(partners);
  const ok = Math.abs(total - 100) < 0.01 && partners.length >= 2;

  return (
    <div className="space-y-2" data-testid="partners-editor">
      <div className="grid grid-cols-[1fr_110px_1fr_36px] gap-2 text-xs text-muted-foreground px-1">
        <span>Partner</span><span>Share %</span><span>Email (optional)</span><span />
      </div>
      {partners.map((p, i) => (
        <div key={i} className="grid grid-cols-[1fr_110px_1fr_36px] gap-2 items-center" data-testid={`partner-row-${i}`}>
          <Input value={p.name} disabled={disabled} placeholder="Full name" onChange={(e) => update(i, { name: e.target.value })} data-testid={`partner-name-${i}`} />
          <Input type="number" min="0" max="100" step="0.01" value={p.profit_share_pct} disabled={disabled} placeholder="50"
                 onChange={(e) => update(i, { profit_share_pct: e.target.value })} data-testid={`partner-share-${i}`} />
          <Input type="email" value={p.email || ''} disabled={disabled} placeholder="name@example.com" onChange={(e) => update(i, { email: e.target.value })} data-testid={`partner-email-${i}`} />
          <Button type="button" variant="ghost" size="icon" disabled={disabled || partners.length <= 2} onClick={() => onChange(partners.filter((_, idx) => idx !== i))} data-testid={`partner-remove-${i}`}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      ))}
      <div className="flex items-center justify-between pt-1">
        <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={() => onChange([...partners, emptyPartner()])} data-testid="partner-add">
          <Plus className="w-4 h-4 mr-1" /> Add partner
        </Button>
        <span className={`text-xs font-medium ${ok ? 'text-emerald-600' : 'text-amber-600'}`} data-testid="partners-total">
          Total {total.toFixed(2)}% {ok ? '· balanced' : '· must equal 100%'}
        </span>
      </div>
    </div>
  );
};
